import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../layouts/Default';
import Billboard from '../components/Billboard';
import SEO from '../components/Seo';
import NewsList from '../components/NewsList';
import Wysiwyg from '../components/Wysiwyg';

import { cleanMetatags, getAlternateLinks, dateToInternational } from '../ui/helpers';

interface IProps {
  data: any;
  pageContext: {
    id: string;
    translations: any;
    countryCode?: string;
    country?: string;
    centerName?: string;
    pagePath: string;
    alternate?: any;
  };
}

const NewsListPage = ({ data, pageContext }: IProps) => {
  const { nodeCenterPage } = data;

  const centerName = pageContext.centerName;

  let newsList = [];
  nodeCenterPage.relationships?.field_centers.map(c => {
    c?.relationships &&
      c?.relationships?.node__news_page &&
      c?.relationships?.node__news_page.map(
        np => np.langcode === nodeCenterPage.langcode && newsList.push(np)
      );
  });

  return (
    <Layout
      alternates={pageContext.alternate}
      lang={nodeCenterPage?.langcode}
      country={pageContext.country}
      countryCode={pageContext.countryCode}
      translations={pageContext.translations}
      pageHref={pageContext.pagePath}>
      <SEO
        title={eval('`' + pageContext.translations.news.list.title + '`')}
        lang={nodeCenterPage?.langcode}
        metas={pageContext.alternate ? pageContext.alternate : []}
      />
      <Billboard
        title={eval('`' + pageContext.translations.news.list.title + '`')}
        size={'billboard-none'}
        breadcrumbs={{
          language: nodeCenterPage?.langcode,
          countryCode: pageContext.countryCode,
          pageHref: {
            alias: nodeCenterPage?.path?.alias,
            domain: nodeCenterPage?.relationships?.field_country?.field_domain?.uri
          },
          additionalLevel: [
            { title: `${pageContext.translations.centerPage.news}`, url: `${pageContext.pagePath}` }
          ]
        }}
      />
      {newsList && newsList.length > 0 ? (
        <NewsList
          news={newsList
            .sort((a, b) => {
              a = dateToInternational(a.created, '/').split('/').join('');
              b = dateToInternational(b.created, '/').split('/').join('');
              return a <= b ? 1 : a > b ? -1 : 0;
            })
            .map((news, i) => ({
              key: `news_${i}`,
              title: news.title,
              text: news.body.summary,
              date: news.created,
              link: {
                uri: `/${news.path?.langcode}${news?.path?.alias}`
              },
              imageUrl:
                news.relationships?.field_billboard_image.relationships?.field_media_image
                  ?.drupal_links,
              imageAlt: news.relationships?.field_billboard_image.field_media_image.alt
            }))}
        />
      ) : (
        <Wysiwyg
          text={`<p style="margin-top: 32px; text-align: center;">${pageContext.translations.news.list.empty}</p>`}
        />
      )}
    </Layout>
  );
};

export const query = graphql`
  query ($id: String) {
    nodeCenterPage(id: { eq: $id }) {
      path {
        alias
        langcode
      }
      langcode
      title
      relationships {
        field_country {
          langcode
          field_country_code
          title
          field_domain {
            uri
          }
        }
        field_centers {
          title
          relationships {
            node__news_page {
              body {
                summary
              }
              created(formatString: "DD/MM/YYYY")
              path {
                alias
                langcode
              }
              title
              langcode
              relationships {
                field_billboard_image {
                  relationships {
                    field_media_image {
                      drupal_links {
                        xsmall_webp {
                          href
                          meta {
                            height
                            width
                          }
                        }
                        xsmall {
                          href
                          meta {
                            height
                            width
                          }
                        }
                      }
                    }
                  }
                  field_media_image {
                    alt
                  }
                }
                field_country {
                  field_country_code
                  field_domain {
                    uri
                  }
                }
              }
            }
          }
        }
      }
      id
    }
  }
`;

export default NewsListPage;
